import type { MessageKey } from './pt-BR';

/** English (US) — same keys as pt-BR. */
export const enUS: Record<MessageKey, string> = {
  'nav.dashboard': 'Dashboard',
  'nav.animals': 'Animals',
  'nav.lots': 'Lots',
  'nav.events': 'Events',
  'nav.movements': 'Movements',
  'nav.movements.short': 'Moves',
  'nav.reproduction': 'Reproduction',
  'nav.reproduction.short': 'Repro.',
  'nav.indicators': 'Zootechnical indicators',
  'nav.indicators.short': 'Zoo.',
  'nav.dairy': 'Dairy control',
  'nav.dairy.short': 'Dairy',
  'nav.sales': 'Sales',
  'nav.sync_conflicts': 'Sync conflicts',
  'nav.sync_conflicts.short': 'Conflicts',
  'nav.admin': 'Administration',
  'nav.expand': 'Expand sidebar',
  'nav.collapse': 'Collapse sidebar',
  'nav.brand.tagline': 'Herd management',
  'nav.footer': 'Manejai System',

  'sex.male': 'Male',
  'sex.female': 'Female',
  'event.weighing': 'Weighing',
  'event.weaning': 'Weaning',
  'event.natural_mount': 'Natural mating',
  'event.insemination': 'Insemination',
  'event.pregnancy_diagnosis': 'Pregnancy diagnosis',
  'event.birth': 'Birth',
  'event.milk_weighing': 'Milk weighing',
  'event.medication': 'Medication / Vaccination',
  'event.milestone': 'Milestone',
  'movement.transfer': 'Transfer',
  'movement.sale': 'Sale',
  'movement.death': 'Death',

  'event.detail.weight': 'Weight',
  'event.detail.weaning_weight': 'Weaning weight',
  'event.detail.production': 'Production',
  'event.detail.drying_off': 'Drying off',
  'event.detail.bull': 'Bull',
  'event.detail.dose': 'Dose',
  'event.detail.route': 'Route',
  'event.detail.product_batch': 'Product batch',
  'event.detail.next_dose': 'Next dose',
  'common.yes': 'Yes',
  'common.dash': '—',

  'settings.title': 'My account',
  'settings.subtitle': 'Profile, language, formats and account details',
  'settings.tab.profile': 'Profile',
  'settings.tab.locale': 'Language & region',
  'settings.tab.notifications': 'Notifications',
  'settings.tab.password': 'Password',
  'settings.tab.client': 'Account details',
  'settings.locale.title': 'Language & region',
  'settings.locale.language': 'Interface language',
  'settings.locale.language_hint':
    'After saving, the menu and language-connected texts switch automatically.',
  'settings.locale.formats_title': 'Account formats',
  'settings.locale.formats_hint':
    'Apply to everyone on this account. API and database stay in kg and ISO dates.',
  'settings.locale.country': 'Country / region',
  'settings.locale.currency': 'Currency',
  'settings.locale.weight_unit': 'Weight unit',
  'settings.locale.date_format': 'Date format',
  'settings.locale.time_format': 'Time format',
  'settings.locale.timezone': 'Time zone',
  'settings.locale.formats_readonly':
    'Only owner/manager can change account formats. You can change the interface language.',
  'settings.locale.saved': 'Preferences updated.',
  'settings.locale.language_saved': 'Language updated.',
  'settings.locale.save_error': 'Could not save.',
  'settings.locale.save': 'Save preferences',
  'settings.locale.save_language': 'Save language',

  'locale.weight.kg': 'Kilogram (kg)',
  'locale.weight.lb': 'Pound (lb)',
  'locale.date.dmy': 'Day / Month / Year',
  'locale.date.mdy': 'Month / Day / Year',
  'locale.date.ymd': 'Year - Month - Day',
  'locale.time.h24': '24-hour',
  'locale.time.h12': '12-hour (AM/PM)',

  'calendar.open': 'Open calendar',
  'calendar.clear': 'Clear',
  'calendar.today': 'Today',
  'calendar.prev_month': 'Previous month',
  'calendar.next_month': 'Next month',
  'calendar.prev_year': 'Previous year',
  'calendar.next_year': 'Next year',

  'animal.access': 'Open animal',
  'common.options': 'Options',
};
